import {
  Goal,
  Flag,
  Dribbble,
  Shield,
  Activity,
  Swords,
  CircleDot,
  Trophy,
} from "lucide-react";

// Icon registry — abstract/generic sport icons only (no official league marks).
export const ICON_MAP = {
  Goal,
  Flag,
  Dribbble,
  Shield,
  Activity,
  Swords,
  CircleDot,
  Trophy,
};

// Static multi-sport catalogue — mirrors the backend seed so the UI renders
// instantly and stays resilient if the API is slow/unreachable.
export const SPORTS = [
  {
    name: "Football",
    slug: "football",
    status: "active",
    icon: "Goal",
    tagline: "AI-powered match analysis & 2026 World Cup intelligence.",
    accent: "#075AEC",
    order: 1,
  },
  {
    name: "Formula 1",
    slug: "formula-1",
    status: "coming_soon",
    icon: "Flag",
    tagline: "Race strategy, pace models & telemetry breakdowns.",
    accent: "#31B3F6",
    order: 2,
  },
  {
    name: "Basketball",
    slug: "basketball",
    status: "coming_soon",
    icon: "Dribbble",
    tagline: "Tempo, efficiency & matchup intelligence.",
    accent: "#075AEC",
    order: 3,
  },
  {
    name: "NFL",
    slug: "nfl",
    status: "coming_soon",
    icon: "Shield",
    tagline: "Drive analytics & gridiron breakdowns.",
    accent: "#31B3F6",
    order: 4,
  },
  {
    name: "Cricket",
    slug: "cricket",
    status: "coming_soon",
    icon: "Activity",
    tagline: "Form curves, conditions & win probability.",
    accent: "#075AEC",
    order: 5,
  },
  {
    name: "MMA",
    slug: "mma",
    status: "coming_soon",
    icon: "Swords",
    tagline: "Style matchups & fight-night analysis.",
    accent: "#31B3F6",
    order: 6,
  },
  {
    name: "Tennis",
    slug: "tennis",
    status: "coming_soon",
    icon: "CircleDot",
    tagline: "Surface form & head-to-head intelligence.",
    accent: "#075AEC",
    order: 7,
  },
];

export const getSportBySlug = (slug) =>
  SPORTS.find((s) => s.slug === slug) || null;
